module.exports = __webpack_public_path__ + "static/media/102418039_245987120178336_1675562743278600192_n.dc2d12b5.jpg";